import Vue from "vue";
import VueRouter from "vue-router";
import First from "../views/First.vue";
import Idea1 from "../views/Idea1.vue";
import Idea2 from "../views/Idea2.vue";
import Idea3 from "../views/Idea3.vue";
import Idea4 from "../views/Idea4.vue";
import IdeaFinish from "../views/IdeaFinish.vue";
import Project1 from "../views/Project1.vue";
import Project2 from "../views/Project2.vue";
import Project3 from "../views/Project3.vue";
import Project4 from "../views/Project4.vue";
import Project5 from "../views/Project5.vue";
import Project6 from "../views/Project6.vue";
import Project7 from "../views/Project7.vue";
import Project8 from "../views/Project8.vue";
import ProjectFinish from "../views/ProjectFinish.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "First",
        component: First,
    },
    {
        path: "/Idea1",
        name: "Idea1",
        component: Idea1,
    },
    {
        path: "/Idea2",
        name: "Idea2",
        component: Idea2,
    },
    {
        path: "/Idea3",
        name: "Idea3",
        component: Idea3,
    },
    {
        path: "/Idea4",
        name: "Idea4",
        component: Idea4,
    },
    {
        path: "/IdeaFinish",
        name: "IdeaFinish",
        component: IdeaFinish,
    },
    {
        path: "/Project1",
        name: "Project1",
        component: Project1,
    },
    {
        path: "/Project2",
        name: "Project2",
        component: Project2,
    },
    {
        path: "/Project3",
        name: "Project3",
        component: Project3,
    },
    {
        path: "/Project4",
        name: "Project4",
        component: Project4,
    },
    {
        path: "/Project5",
        name: "Project5",
        component: Project5,
    },
    {
        path: "/Project6",
        name: "Project6",
        component: Project6,
    },
    {
        path: "/Project7",
        name: "Project7",
        component: Project7,
    },
    {
        path: "/Project8",
        name: "Project8",
        component: Project8,
    },
    {
        path: "/ProjectFinish",
        name: "ProjectFinish",
        component: ProjectFinish,
    },
];

const router = new VueRouter({
    routes,
});

export default router;
